<template>
  <ul class="td-list">
    <li v-for="(item, idx) in sorted(items)" :key="idx">
      {{ item }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SimpleList',
  props: {
    items: Array,
  },
  methods: {
    sorted(list) {
      return this.$utils.sortIgnoringCase(this.$utils.deepCopy(list));
    },
  },
};
</script>
